import { OfertaMercader } from "@pages/producto/mercader/OfertaMercader";

/**
 * Pre-oferta del wizard v2 por tenant. Cada empresa tiene su página porque cambia la estructura, no solo los
 * datos: de dónde salen (Mercader: leasing; Flux: la línea), qué se puede editar y qué hace "Aceptar". Todas
 * comparten la tarjeta `CardPreOferta`. El marketplace no va aquí: su pantalla es la comparativa de ofertas
 * por financiera (`Ofertas`, ruta `seleccionando_oferta`).
 */
export const ofertaPorEmpresa: Record<string, React.FC> = {
  mercader: OfertaMercader,
};
